import { render, staticRenderFns } from "./NasalSwabCheck.vue?vue&type=template&id=0d883790&scoped=true&"
import script from "./NasalSwabCheck.vue?vue&type=script&lang=js&"
export * from "./NasalSwabCheck.vue?vue&type=script&lang=js&"
import style0 from "./NasalSwabCheck.vue?vue&type=style&index=0&id=0d883790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d883790",
  null
  
)

export default component.exports